import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'


//main.js
import axios from 'axios'
Vue.prototype.$axios = axios
import uuid from 'uuid'

import '@/icons' // icon
import '@/permission' // permission control

Vue.use(ElementUI, { locale })
Vue.use(VCharts)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})


// main.js
Vue.mixin({
  beforeCreate() {
    if (this.$options.name === 'ElTable') {
      this.$options.props = {
        ...this.$options.props,
        border: {
          type: Boolean,
          default: true // 强制启用边框以激活拖拽
        }
      };
    }
  }
});



// WEBPACK FOOTER //
// ./src/main.js